import { render, staticRenderFns } from "./update_student.vue?vue&type=template&id=42edf3dc&scoped=true"
import script from "./update_student.vue?vue&type=script&lang=js"
export * from "./update_student.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/student-edit.scss?vue&type=style&index=0&id=42edf3dc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42edf3dc",
  null
  
)

export default component.exports